import * as React from "react";
import { cn } from "@/lib/utils";

/** Shared field chrome — plan/27 tokens, touch-friendly height. */
export const fieldControlClass =
  "flex h-11 w-full rounded-md border border-[var(--color-border)] bg-[var(--color-card)] px-3 py-2 text-sm text-[var(--color-foreground)] shadow-[var(--shadow-control)] transition-colors placeholder:text-[var(--color-muted-fg)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)] disabled:cursor-not-allowed disabled:opacity-50";

export const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(fieldControlClass, className)}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";
